<template>
  <div v-if="!item.hidden" class="menu-wrapper">
    <template v-if="!hasChild_">
      <app-link v-if="item.meta" :to="resolvePath(item.path)">
        <el-menu-item
          :index="item.meta.id"
          :disabled="item.disabled"
          :class="{ 'submenu-title-noDropdown': !isNest }"
        >
          <item :icon="item.meta.icon" :title="item.meta.title" />
        </el-menu-item>
      </app-link>
    </template>
    <el-submenu
      v-else
      ref="subMenu"
      :index="item.meta && item.meta.id"
      :disabled="item.disabled"
      popper-class="top-nav-popup"
      :popper-append-to-body="!isNest"
    >
      <template slot="title">
        <item
          v-if="item.meta"
          :icon="item.meta.icon"
          :title="item.meta.title"
        />
      </template>
      <top-nav-item
        v-for="child in item.children"
        :key="child.id"
        is-nest
        :item="child"
        :base-path="resolvePath(child.path)"
        :link-props="linkProps"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import Item from './Item'
import AppLink from './Link'
import FixIOSBug from './FixiOSBug'

export default {
  name: 'TopNavItem',
  components: { AppLink, Item }, // Item
  mixins: [FixIOSBug],
  props: {
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    },
    linkProps: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    // 是否存在显示的子级
    hasChild_() {
      if (this.item.children && this.item.children.length > 0) {
        const child = this.item.children.filter((v) => {
          return v.hidden !== true
        })
        return child.length > 0
      }
      return false
    }
  },
  methods: {
    isExternal(path) {
      return /^(https?:|mailto:|tel:)/.test(path)
    },
    resolvePath(routePath) {
      if (this.isExternal(routePath)) {
        const urlParams = new URL(routePath)
        Object.entries(this.linkProps).forEach(([k, v]) => {
          if (urlParams.searchParams.has(k)) {
            urlParams.searchParams.set(k, v)
          } else {
            urlParams.searchParams.append(k, v)
          }
        })
        const url = urlParams.toString()
        return url
      }
      return path.resolve(this.basePath, routePath)
    }
  }
}
</script>
